import Vue from 'vue'
import VueRouter from 'vue-router'

import AboutUs from '@/pages/about-us/about-us'
import Contact from '@/pages/contact/contact'
import Home from '@/pages/home/home'
import PatientInfo from '@/pages/patient-info/patient-info'
import SmileGallery from '@/pages/smile-gallery/smile-gallery'
import Treatments from '@/pages/treatments/treatments'
import Accessibility from '@/pages/accessibility/accessibility'
import Styleguide from '@/pages/styleguide/styleguide'
import scrollBehavior from '@/shared/functionality/scroll-behavior'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      navigation: true,
      component: Home
    },
    {
      path: '/about-us',
      name: 'About Us',
      navigation: true,
      component: AboutUs
    },
    {
      path: '/patient-info',
      name: 'Patient Info',
      navigation: true,
      component: PatientInfo
    },
    {
      path: '/treatments',
      name: 'Treatments',
      navigation: true,
      component: Treatments
    },
    {
      path: '/smile-gallery',
      name: 'Smile Gallery',
      navigation: false,
      component: SmileGallery
    },
    {
      path: '/contact',
      name: 'Contact',
      navigation: true,
      component: Contact
    },
    {
      path: '/accessibility',
      name: 'Accessibility',
      navigation: false,
      component: Accessibility
    },
    {
      path: '/styleguide',
      name: 'Styleguide',
      navigation: false,
      component: Styleguide
    },
    {
      path: '/*',
      name: '404',
      navigation: false,
      component: Home
    }
  ],
  scrollBehavior
})

router.afterEach((to, from) => {
  window.scrollTo(0, 0)
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js